import React, { useCallback, useEffect, useMemo, useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Box, Button, Radio, Stack } from '@mui/material'
import { Item } from '../../../common/snippets'
import DropDownOA from '../../../common/dropDownOA'
import Lineinput from '../../../common/lineinput'
import Modal from '../../../common/modal'
import { GetRequest, PostRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { useAtom } from 'jotai'
import { alertAtom } from '../../../common/jotaiState/globalStateAtoms'
import { removeDuplicatesFromArray } from '../../../common/helper'
import { exportToExcel } from '../../../common/hook'
import { useTranslation } from '../../../../i18n/I18nProvider'

const blankMpesaConfig = {
    consumerKey: '',
    secretKey: '',
    paybillNumber: '',
    passKey: '',
}

const MpesaConfigurationModel = (props) => {
    const { translations } = useTranslation()
    const mtpl = translations?.mtplMaster || {}
    const { updateModal, loginData, selEditLuggageSetting, companyMpesaSettingData, handleSaveSetting } = props
    const [, setAlert] = useAtom(alertAtom)
    const mpesaSettingList = useMemo(
        () => (Array.isArray(companyMpesaSettingData) ? companyMpesaSettingData : companyMpesaSettingData ? [companyMpesaSettingData] : []),
        [companyMpesaSettingData]
    )
    const modalStyle = useMemo(() => ({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
            paddingTop: "10px"
        }), []);
    const [configType, setConfigType] = useState('company')
    const [sourceBranchList, setSourceBranchList] = useState([])
    const [selSourceBranch, setSelSourceBranch] = useState()
    const [mpesaConfig, setMpesaConfig] = useState(blankMpesaConfig)
    const bindMpesaConfig = useCallback((configData) => {
        setMpesaConfig({
            consumerKey: configData?.ConsumerKey || '',
            secretKey: configData?.ConsumerSecretKey || '',
            paybillNumber: configData?.PayBillNo || '',
            passKey: configData?.Passkey || '',
        })
    }, [])
    const getMpesaConfigByBranch = useCallback(
        (branchID) => mpesaSettingList.find((item) => Number(item?.BranchID || 0) === Number(branchID || 0)),
        [mpesaSettingList]
    )

    useEffect(() => {
        const obj = {
            intUserID: 0,
            intCompanyID: selEditLuggageSetting?.CompanyID || 0,
            intBranchID: 0,
            strBranchName: '',
            strBranchCode: '',
            intStateID: 0,
            intCityID: 0,
            intIsActive: 1,
        }
        PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
            if (res.status === 'Success') {
                const list = res?.Data?.Table || []
                setSourceBranchList(list)
            } else {
                setSourceBranchList([])
                setAlert({ show: true, msg: res?.ErrMessage || mtpl.branchListNotFound || 'Branch list not found', nextId: '' })
            }
        })
    }, [selEditLuggageSetting?.CompanyID, setAlert])

    useEffect(() => {
        setConfigType('company')
        setSelSourceBranch()
        bindMpesaConfig(getMpesaConfigByBranch(0))
    }, [bindMpesaConfig, companyMpesaSettingData, getMpesaConfigByBranch])

    const handleConfigTypeChange = (type) => {
        setConfigType(type)
        if (type === 'company') {
            setSelSourceBranch()
            bindMpesaConfig(getMpesaConfigByBranch(0))
        } else {
            setSelSourceBranch()
            setMpesaConfig(blankMpesaConfig)
        }
    }

    const handleBranchChange = (val) => {
        setSelSourceBranch(val)
        bindMpesaConfig(getMpesaConfigByBranch(val?.BranchID))
    }

    const handleMpesaChange = (e) => {
        const { name, value } = e.target
        setMpesaConfig((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const handleSaveMpesaConfig = () => {
        if (configType === 'branch' && !selSourceBranch?.BranchID) {
            setAlert({ show: true, msg: mtpl.pleaseSelectBranchLower || 'Please select branch', nextId: 'mpesaBranch' })
            return
        }

        const loginBranchID = loginData?.inBranchID || loginData?.intBranchID || 0
        const mpesaBranch = configType === 'company' ? 0 : Number(selSourceBranch?.BranchID || 0)
        const mpesaPayload = {
            BaseUserID: loginBranchID,
            UserID: loginBranchID,
            MpesaBranch: mpesaBranch,
            MpesaConsumerKey: mpesaConfig.consumerKey,
            MpesaSecretKey: mpesaConfig.secretKey,
            MpesaPaybillNo: mpesaConfig.paybillNumber,
            MpesaPassKey: mpesaConfig.passKey,
        }
        handleSaveSetting(mpesaPayload, updateModal, mtpl.mpesaUpdatedSuccessfully || 'Mpesa configuration updated successfully')
    }

    const handleExportExcel = async () => {

        const selectedBranchId = configType === 'company' ? -1 : Number(selSourceBranch?.BranchID || 0)
        const params = {
            intCompanyId: selEditLuggageSetting?.CompanyID || loginData?.intCompanyID || 0,
            intBranchId: selectedBranchId,
        }

        const res = await GetRequest(urls.getPayBillDetails, params)
        if (res?.status !== 'Success') {
            setAlert({ show: true, msg: res?.ErrMessage || mtpl.unableToDownloadExcel || 'Unable to download excel', nextId: '' })
            return
        }

        const tableData = res?.Data?.Table || []
        if (tableData.length === 0) {
            setAlert({ show: true, msg: mtpl.noDataFound || 'No Data Found!', nextId: '' })
            return
        }

        const isBranchWise = configType === 'branch'
        const companyName = tableData?.[0]?.CompanyName || selEditLuggageSetting?.CompanyName || loginData?.strCompanyName || ''
        const excelHeaders = [
            { field: 'sn', header: mtpl.sr || 'SN', textAlign: 'right' },
            { field: 'name', header: isBranchWise ? (mtpl.selectBranch || 'Branch Name') : (mtpl.companyName || 'Company Name'), textAlign: 'left' },
            { field: 'ConsumerKey', header: mtpl.consumerKey || 'Consumer Key', textAlign: 'left' },
            { field: 'ConsumerSecretKey', header: mtpl.secretKey || 'Secret Key', textAlign: 'left' },
            { field: 'PaybillNo', header: mtpl.paybillNumber || 'Paybill No', textAlign: 'left' },
            { field: 'Passkey', header: mtpl.passKey || 'Pass Key', textAlign: 'left' },
        ]
        const reportHeader = [
            [
                { header: `Company Name: ${companyName}`, field: '', span: excelHeaders.length, mainHeader: true, skipSpace: true },
            ],
            [
                { header: 'Mpesa Credentials', field: '', span: excelHeaders.length },
            ],
        ]
        const excelData = tableData.map((item, index) => ({
            sn: index + 1,
            name: isBranchWise ? item?.BranchName || '' : item?.CompanyName || '',
            ConsumerKey: item?.ConsumerKey || item?.MpesaConsumerKey || '',
            ConsumerSecretKey: item?.ConsumerSecretKey || item?.SecretKey || item?.MpesaSecretKey || '',
            PaybillNo: item?.PaybillNo || item?.PayBillNo || item?.MpesaPaybillNo || '',
            Passkey: item?.Passkey || item?.PassKey || item?.MpesaPassKey || '',
            dataType: 'entry',
        }))

        exportToExcel({
            fileName: `Mpesa Credentials.xlsx`,
            sheetName: 'Mpesa Credentials',
            headersList: [reportHeader, excelHeaders],
            dataList: [[], excelData],
        })
    }

    const renderInputRow = (label, id, name) => (
        <Stack direction="row" alignItems="center" spacing={2} sx={{ marginBottom: '20px',width: '100%',display:'flex',justifyContent:'center' }}>
            <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '100%' }}>
                <Lineinput
                    id={id}
                    name={name}
                    label={label}
                    value={mpesaConfig[name]}
                    onChange={handleMpesaChange}
                    style={{ width: '100%' }}
                />
            </Item>
        </Stack>
    )

  return (
    <>
            <Modal
                headTxt={mtpl.mpesaConfiguration || 'Mpesa configuration'}
                width="30%"
                updateModal={updateModal}
                closeId="closeButton"
                modalClass="booking-popup"
                modalStyle={modalStyle}
            >
                <Box
                    className="BranchPageTabContainer scrollBlue"
                    sx={{
                        minHeight: '44vh',
                        overflowY: 'auto',
                        padding: '20px 45px',
                        fontFamily: 'Roboto',
                        fontSize: '16px',
                        color: '#444',
                        width:'100%'
                    }}
                >
                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={5} sx={{ marginBottom: '24px',width: '100%' }}>
                        <label htmlFor="mpesaCompanyWise" style={{ display: 'flex', alignItems: 'center', fontWeight: '700',justifyContent:'left',width:'50%' }}>
                            <Radio
                                id="mpesaCompanyWise"
                                checked={configType === 'company'}
                                onChange={() => handleConfigTypeChange('company')}
                                name="mpesaConfigType"
                            />
                            {mtpl.companyWise || 'Company Wise'}
                        </label>
                        <label htmlFor="mpesaBranchWise" style={{ display: 'flex', alignItems: 'center', fontWeight: '700',justifyContent:'left',width:'50%' }}>
                            <Radio
                                id="mpesaBranchWise"
                                checked={configType === 'branch'}
                                onChange={() => handleConfigTypeChange('branch')}
                                name="mpesaConfigType"
                            />
                            {mtpl.branchWise || 'Branch Wise'}
                        </label>
                    </Stack>

                    {configType === 'branch' ? (
                        <Stack direction="row" alignItems="center" spacing={2} sx={{ marginBottom: '20px' }}>
                            {/* <div style={{ width: '25%', textAlign: 'right', fontWeight: '700' }}>Branches:</div> */}
                            <Item sx={{ ...sx.itemsx, width: '100%' }}>
                                <DropDownOA
                                    label={mtpl.selectBranch || 'Select Branch'}
                                    id="mpesaBranch"
                                    data={removeDuplicatesFromArray(sourceBranchList, 'BranchID') || []}
                                    defaultvalue={selSourceBranch?.BranchName || selSourceBranch || ''}
                                    onSelect={handleBranchChange}
                                    noCross={true}
                                    idKey="BranchID"
                                    dataKey="BranchName"
                                    minWidth="100%"
                                    nextId="mpesaConsumerKey"
                                />
                            </Item>
                        </Stack>
                    ) : null}

                    {renderInputRow(mtpl.consumerKey || 'Consumer Key', 'mpesaConsumerKey', 'consumerKey')}
                    {renderInputRow(mtpl.secretKey || 'Secret Key', 'mpesaSecretKey', 'secretKey')}
                    {renderInputRow(mtpl.paybillNumber || 'Paybill Number', 'mpesaPaybillNumber', 'paybillNumber')}
                    {renderInputRow(mtpl.passKey || 'Pass Key', 'mpesaPassKey', 'passKey')}

                    <Stack direction="row" justifyContent="right" spacing={4}>
                        <Button
                            variant="contained"
                            id="excelBtn"
                            className="btn btn-primary"
                            onClick={handleExportExcel}
                            sx={{ backgroundColor: '#ff5200', color: '#fff', width: '120px' }}
                        >
                            {mtpl.excel || 'Excel'}
                        </Button>
                        <Button
                            variant="contained"
                            id="closeBtn"
                            className="btn btn-primary"
                            onClick={() => updateModal(false)}
                            sx={{ backgroundColor: '#ff5200', color: '#fff', width: '120px' }}
                        >
                            {mtpl.close || 'close'}
                        </Button>
                        <Button
                            variant="contained"
                            id="saveBtn"
                            className="btn btn-primary"
                            onClick={handleSaveMpesaConfig}
                            sx={{ backgroundColor: '#ff5200', color: '#fff', width: '120px' }}
                        >
                            {mtpl.save || 'save'}
                        </Button>
                    </Stack>
                </Box>
            </Modal>

        </>
  )
}

export default MpesaConfigurationModel
